import React from 'react'
import LearnMoreLogo from '.././../../../Assets/Images/LearnMoreLogo-removebg-preview.png'
import learnmoreThumb from '.././../../../Assets/Images/learnmorethumb.png'
import "./LearnMore.css";
import learnmoreimg from "../../../../Assets/Images/image-removebg-preview.png";
                                                                                                                                                        
export default function LearnMore() {
    return (
        <div className='learnmore' id="about">
            <div className="container">
                <div className="learnmore-top">
                    <img src={LearnMoreLogo} alt="" className="learnmore-logo" />
                    <h2 className="learnmore-title">
                        A Multi <b> Agri-commodity </b> Processing company  with ,
                    </h2>
                    <img src={learnmoreThumb} alt="" className="learnmore-thumb" />
                </div>
                <div className="learnmore-bottom">
                    <ul className="learnmore-list">
                  <div className='learnmore-flex'>
                        <li className="learnmore-item">
                           <div className='learnmore-header'>
                             <h3 className="learnmore-subtitle">
                            World class infrastructure.
                            </h3>
                            <span className='learnmore-number'>
                            01
                            </span>
                            </div>
                            <p className="learnmore-subtext">
                            One of the Best infrastructure with highly maintained facilities, processing & packing units.                            </p>
                            <a href="#" className="learnmore-link">
                            learn more
                            </a>
                        </li>
                        <li className="learnmore-item">
                           <div className='learnmore-header'> <h3 className="learnmore-subtitle">
                           Most Hygienic environment.                            </h3>
                            <span className='learnmore-number'>
                            03
                            </span>
                            </div>
                            <p className="learnmore-subtext">
                            Most hygienic and controlled packing stations & environment which meets international standards.                            </p>
                            <a href="#" className="learnmore-link">
                            learn more
                            </a>
                        </li>
                        </div>
                        <span className='learnmore-hr'></span>
                        <div className='learnmore-flex'>
                        <li className="learnmore-item">
                           <div className='learnmore-header'>
                             <h3 className="learnmore-subtitle">
                             Best in the world technology.                            </h3>
                            <span className='learnmore-number'>
                            02
                            </span>
                            </div>
                            <p className="learnmore-subtext">
                            Most Advanced plant with latest technologies and machinery to maximize quality and accuracy.                             </p>
                            <a href="#" className="learnmore-link">
                            learn more
                            </a>
                        </li>
                        <li className="learnmore-item">
                           <div className='learnmore-header'> <h3 className="learnmore-subtitle">
                           Skilled, experienced & dedicated team.                            </h3>
                            <span className='learnmore-number'>
                            04
                            </span>
                            </div>
                            <p className="learnmore-subtext">
                            Our team is dedicated ,skilled & experienced, we also conduct regular inhouse training programmes                            </p>
                            <a href="#" className="learnmore-link">
                            learn more
                            </a>
                        </li>
                        </div>
                    </ul>
                </div>
            </div>

        </div>
    )
}
